import * as React from 'react';
import Box from '@mui/material/Box';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';

import Bs4GenericField from './Bs4GenericField';
import { UxTemplateEditor, ViewColorBox, useStateUxTemplate } from '../../Bs4Theme/Bs4UxTemplates';
import { TYPE_APPBAR } from '../../Bs4MainWindow';

const TYPE_BS4BOXCSS = 'type_Bs4BoxCss';

export default class Bs4BoxCss extends Bs4GenericField {
  uxEditor = new UxTemplateEditor();  

  setValueBs4(value) {
    try {
      this.setValue(JSON.parse(value));  
    } catch {
      this.setValue({});
    }
  }

  getValueBs4(value) {    
    try {
      return JSON.stringify(this.getValue());    
    } catch {
      return null;
    }    
  }

  setValue = (value) => {
    let v = value;
    if (!v || typeof v !== 'object' || Array.isArray(v)) v = {};
    super.setValue(v);
  }

  getValue = () => {
    if (!this.value || typeof this.value !== 'object' || Array.isArray(this.value)) this.value = {};
    return this.value;
  }

  ViewUxTemplate = (props) => {
    const formField = this;
    const type = TYPE_BS4BOXCSS;
    const {setUxTemplateUpdate} = useStateUxTemplate(TYPE_BS4BOXCSS);
    const tabs = React.useMemo(() => {
      return [{
        label: 'Base',
        Content: (props) => {
          return (
            <Box display='flex' flexDirection='column' p={1.5}>
              <formField.uxEditor.ViewCssColor types={type} value={formField.getValue()} name='color' title='Tekst'/>
              <formField.uxEditor.ViewCssColor types={type} value={formField.getValue()} name='backgroundColor' title='Tło'/>
            </Box>
          );
        },
      }, {
        label: 'More...' ,
        Content: (props) => {
          return (
            <Box display='flex' flexDirection='column' p={1.5}>
              {/* <formField.uxEditor.ViewCssColor types={type} value={formField.getValue()} name='color' title='Tekst'/> */}
              {/* <formField.uxEditor.ViewCssColor types={type} value={formField.getValue()} name='backgroundColor' title='Tło'/> */}
              <formField.uxEditor.ViewCssColor types={type} value={formField.getValue()} name='borderColor' title='Ramka'/>
              <formField.uxEditor.ViewCssShadow types={type} value={formField.getValue()} name='elevation'/>
              <formField.uxEditor.ViewCssText types={type} value={formField.getValue()} name='borderRadius'/>
              <formField.uxEditor.ViewCssText types={type} value={formField.getValue()} name='borderWidth'/>
              <formField.uxEditor.ViewCssText types={type} value={formField.getValue()} name='margin'/>
              <formField.uxEditor.ViewCssText types={type} value={formField.getValue()} name='padding'/>
            </Box>
          );
        },
      }]
    }, [])

    const handleReset = (event, tab) => {
      this.setValue({});
      setUxTemplateUpdate(TYPE_BS4BOXCSS); 
    }    

    return (
      <formField.uxEditor.ViewUxTemplate      
        open={props.open}
        onClose={props.onClose}
        onReset={handleReset}
        types={Bs4BoxCss.types} 
        title={<ViewColorBox value={formField.getValue()}/>}
        tabs={tabs}
        noMenu
      />
    )
  } 

  ViewComponentField = (props) => {
    const formField = this;
    const {} = useStateUxTemplate(TYPE_BS4BOXCSS);
    const [open, setOpen] = React.useState(false);
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR);
    
    this.refFocus = React.useRef();

    const handleClick = (event) => {
      setOpen(!open)
    }    

    React.useEffect(() => {      
      this.notValidElementDom = (text) => {
        setError({error: true, helperText: text})
      }
      
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      })
    }, [error]);

    console.log('... Css Css Css ... 2', props, this.getValue())

    const icon1 = "fa-solid fa-paintbrush";
    const icon2 = "fa-regular fa-paintbrush"
    
    return (      
      <FormControl ref={formField.refFocus} id={formField.getElementId()} fullWidth error={error.error} >
        {!formField.props?.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        <ViewColorBox value={formField.getValue()} onClick={handleClick}/>
        <FormHelperText>{error.helperText}</FormHelperText>
        <formField.ViewUxTemplate open={open} onClose={() => setOpen(false)}/>
      </FormControl>            
    )
  }
}